

















import { Component, Vue, Prop } from 'vue-property-decorator';

import BusinessService from '@/api/BusinessService';

import {
  ECustomerInactivityStepSlug,
  ICustomerInactivityFormData
} from '@/models/customer-inactivity';

import CustomerInactivityForm from '@/componentsV2/organisms/CustomerInactivityForm/CustomerInactivityForm.vue';
import { IOption } from '@/componentsV2/molecules/Inputs/RadioGroupWithCustom.vue';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    CustomerInactivityForm
  }
})
export default class EditInactivity extends Vue {
  @Prop() customerInactiveFormData!: ICustomerInactivityFormData;

  businessService = new BusinessService();
  loading = false;

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  handleCancel() {
    this.$emit('customer-inactivity-event', { type: 'closeModal' });
  }

  handleGoToInfoStep() {
    segmentIo.modal('Inactive Consumers Learn More', {
      From: 'Inactive Consumers Edit Modal'
    });
    this.$emit('customer-inactivity-event', {
      type: 'goToStep',
      params: { redirectToStep: ECustomerInactivityStepSlug.INFO }
    });
  }

  async handleSubmit(formData: IOption<number>) {
    this.loading = true;

    try {
      const numberOfDays = formData.value;

      await this.businessService.setCustomerInactivityDays(numberOfDays);

      this.$notification(
        'Customer inactivity time frame updated successfully!'
      );
      this.$store.dispatch('business/SET_BUSINESS_INFO', {
        ...this.businessInfo,
        inactiveCustomerDays: numberOfDays
      });
      this.$emit('customer-inactivity-event', { type: 'confirm' });
    } finally {
      this.loading = false;
    }
  }
}
